<template>
  <div class="home">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="top">
        <!-- <img src="@/assets/top.png" /> -->
      </div>
      <div class="content">
        <div class="category">
          <van-grid :gutter="10" :border="false">
            <van-grid-item v-for="(icon, idx) in icons" :key="idx" @click="goToTask(icon.key)">
              <slot name="icon">
                <div class="icon-wrap">
                  <img :src="icon.src" />
                </div>
              </slot>

              <slot name="text">
                <div class="text">{{ icon.text }}</div>
              </slot>
            </van-grid-item>
          </van-grid>
        </div>
        <!-- <div class="list-title">新订单</div> -->

        <div style="marginBottom:20px; borderRadius:10px; overflow:hidden;">
          <template v-if="list.length > 0">
            <van-sticky style="">
              <van-search v-model="serachValue" placeholder="请输入搜索关键词" @search="handleSearchChange" @clear="handleSearchChange" />
            </van-sticky>
          </template>
        </div>

        <div class="list-box">
          <template v-if="skeletonLoading">
            <div class="list-item" v-for="n in 4" :key="n">
              <van-skeleton title avatar :row="3" :loading="skeletonLoading"></van-skeleton>
            </div>
          </template>
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            v-if="list.length > 0"
            @load="onLoad"
          >
            <div class="list-item" v-for="item in list" :key="item.id">
              <div class="list-item-header">
                <img :src="getIconSrc(item.busiType)" :style="{ width: '60px' }" />
                <div class="title">{{ getIconName(item.busiType) }}</div>
              </div>
              <div class="list-item-content">
                <div class="item">
                  <div class="point"></div>
                  <div class="tag">派单日期</div>
                  <div class="tag-content">{{ item.orderDate }}</div>
                </div>
                <div class="item">
                  <div class="point"></div>
                  <div class="tag">姓名</div>
                  <div class="tag-content">{{ item.carOwnerName }}</div>
                </div>
                <div class="item">
                  <div class="point"></div>
                  <div class="tag">车牌</div>
                  <div class="tag-content">{{ item.plateNumber }}</div>
                </div>
                <div class="item">
                  <div class="point"></div>
                  <div class="tag">手机号</div>
                  <div class="tag-content">
                    <a :href="'tel:' + item.carOwnerMobile">
                      {{ item.carOwnerMobile }}
                    </a>
                </div>
                </div>
              </div>
              <div class="list-item-actions">
                <van-button
                  @click="
                    $router.push({ path: '/waitingForOrder', query: { orderNo: item.orderNo } })
                  "
                  type="primary"
                  round
                  block
                  color="#FF5A40"
                  >去接单</van-button
                >
              </div>
            </div>
          </van-list>
          <van-empty description="暂无订单" v-else />
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { queryPost } from "@/core/service/api";

let current = 1;

export default {
  name: "home",
  data() {
    return {
      icons: [
        // { src: require("@/assets/icons/1.svg"), text: "抵押登记", key: 1000 },
        // { src: require("@/assets/icons/2.svg"), text: "解押登记", key: 1010 },
        // { src: require("@/assets/icons/3.svg"), text: "车管所备案", key: 1020 },
        // { src: require("@/assets/icons/4.svg"), text: "新车上户", key: 1030 },
        // { src: require("@/assets/icons/5.svg"), text: "二手车过户", key: 1040 },
        // { src: require("@/assets/icons/6.svg"), text: "补登记证", key: 1050 },
        // { src: require("@/assets/icons/7.svg"), text: "补行驶证", key: 1060 },
        // { src: require("@/assets/icons/8.svg"), text: "车辆年检", key: 1070 }
      ],
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      skeletonLoading: true,
      serachValue: ''
    };
  },
  created() {
    setTimeout(() => {
      this.fetchData();
    }, 300);
  },
  methods: {
    goToTask(key) {
      // if (key === 1010 || key === 1000) {
        
      // } else {
      //   this.$toast("暂未开通");
      // }
      this.$router.push(`/full/task/${key}`);
    },
    async onLoad() {
      current += 1;
      await this.fetchData();
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      current = 1;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.fetchData();
    },
    async fetchData() {
      const payload = {
        query: {
          orderStatus: 1020,
          queryParam:this.serachValue
        },
        form: {},
        pagination: { current, pageSize: 10 }
      };
      const response = await queryPost(payload, "/app/index/order/list");
      this.skeletonLoading = false;
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      this.loading = false;

      if (response) {
        const { code, body } = response;
        if (code === 200) {
          const {
            list,
            pagination: { total }
          } = body;
          this.list = this.list.concat(list);

          if (this.list.length >= total) {
            this.finished = true;
          }
        }
      }
    },
    getIconSrc(key) {
      return this.icons.find(item => item.key === key)?.src;
    },
    getIconName(key) {
      return this.icons.find(item => item.key === key)?.text;
    },
    handleSearchChange(){
      this.$nextTick(() => {
        document.getElementsByClassName('top')[0].scrollIntoView()
      }); 
  

      this.refreshing = true;
      setTimeout(() => {
        this.onRefresh();
      }, 300);
    }
  }
};
</script>
<style lang="scss">
.home {
  padding: 20px 10px 0 10px;
  background-color: #eff0f5;
  .van-grid-item__content {
    padding: 8px 0px !important;
  }

  .top {
    width: 78.93%;
    margin: 0 auto;
    padding-top: 20px;
  }
  .content {
    position: relative;
    top: -36px;
  }
  .category {
    position: relative;
    background: #fff;
    border-radius: 10px;
    margin-bottom: 20px;
  }
  .list-title {
    background-color: #fff;
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 20px;
    color: #323232;
    font-size: 16px;
    font-weight: 600;
  }
  .list-box {
    position: relative;
    // top: -20px;
  }
  // .icon-wrap {
  //   // width: 60%;
  // }
  .text {
    font-size: 12px;
  }
  .list-item {
    background: #fff;
    border-radius: 10px;
    padding: 15px 20px;
    margin-bottom: 15px;
    &-header {
      display: flex;
      align-items: center;
      .title {
        color: #323232;
        font-size: 16px;
        font-weight: 600;
        // padding-left: 6px;
        position: relative;
        left: -6px;
      }
    }
    &-content {
      padding-top: 10px;
      .item {
        display: flex;
        font-weight: 400;
        font-size: 13px;
        align-items: center;
        padding-left: 20px;
        margin-bottom: 4px;
      }
      .point {
        width: 5px;
        height: 5px;
        background-color: #ff5a40;
        border-radius: 50%;
        margin-right: 6px;
      }
      .tag {
        color: #323232;
        position: relative;
        width: 54px;
        text-align-last: justify;
      }
      .tag-content {
        color: #646464;
        padding-left: 14px;
      }
    }
    &-actions {
      margin-top: 15px;
    }
  }
}
</style>
